module.exports = __webpack_public_path__ + "img/chrome.e82c3cd8.svg";